import React from 'react';

import { BoldText, Contact } from './AdditionalInfo.styled';
import { MemberServicesPhoneLink } from 'screens/Book/components/MemberServicesPhoneLink';

export const AdditionalInfoProviderSearch = ({
  phone,
  hideInPersonOption = false
}: {
  phone?: string;
  hideInPersonOption?: boolean;
}): JSX.Element => {
  return (
    <>
      {hideInPersonOption ? (
        <BoldText>
          If you don’t see a date/time available that works for your schedule, please call us at{' '}
          <MemberServicesPhoneLink phone={phone} />.
        </BoldText>
      ) : (
        <BoldText>
          If you don’t see a date/time available that works for your schedule, or if you'd prefer to
          book an in-person visit, please call us at <MemberServicesPhoneLink phone={phone} />.
        </BoldText>
      )}
      <br />
      If you would like to book with a specific doctor, please visit our{' '}
      <Contact
        href="https://kindbody.com/kindbody-doctors/"
        target="_blank"
        rel="noreferrer noopener"
      >
        doctor pages
      </Contact>
      .
    </>
  );
};
